import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const BreadCrumbs = ({ breadСrumbs }) => (
  <nav className="breadcrumbs-container">
    <ol
      className="breadcrumbs"
      itemScope
      itemType="https://schema.org/BreadcrumbList"
    >
      {breadСrumbs.map((item, i) => (
        <li
          key={item.url}
          className={cn("breadcrumbs__item", {
            breadcrumbs__last: i === breadСrumbs.length - 1 && i !== 0,
          })}
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
        >
          <a itemProp="item" href={item.url}>
            <span itemProp="name">{item.name}</span>
          </a>
          <meta itemProp="position" content={i + 1} />
        </li>
      ))}
    </ol>
  </nav>
);

BreadCrumbs.propTypes = {
  breadСrumbs: PropTypes.array,
};

export default BreadCrumbs;



// WEBPACK FOOTER //
// ./app/frontend/components/BreadCrumbs.js